import React, { useState, useEffect, useCallback } from 'react';
import { dashboardAPI, dashboardAvanzadoAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import PersonalDashboard from './PersonalDashboard';
import DashboardClaude from './DashboardClaude';

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [kpis, setKpis] = useState(null);
  const [deudas, setDeudas] = useState([]);
  const [vencimientos, setVencimientos] = useState([]);
  const [ingresosMensuales, setIngresosMensuales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hoy = new Date();
  const [resumenFinancieroPeriodo, setResumenFinancieroPeriodo] = useState({
    modo: 'mes',
    mes: String(hoy.getMonth() + 1),
    anio: String(hoy.getFullYear())
  });
  const [resumenFinanciero, setResumenFinanciero] = useState(null);
  const [loadingResumenFinanciero, setLoadingResumenFinanciero] = useState(false);

  const loadDashboardData = async () => {
    try {
      setLoading(true);
      const [kpisResponse, deudasResponse, vencimientosResponse, ingresosResponse] = await Promise.all([
        dashboardAPI.getKPIs(),
        dashboardAPI.getDeudasPorCliente(),
        dashboardAPI.getVencimientos(7),
        dashboardAPI.getIngresosMensuales()
      ]);

      setKpis(kpisResponse.data);
      setDeudas(deudasResponse.data);
      setVencimientos(vencimientosResponse.data);
      setIngresosMensuales(ingresosResponse.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const cargarResumenFinanciero = useCallback(async (periodo = resumenFinancieroPeriodo) => {
    try {
      setLoadingResumenFinanciero(true);
      const params =
        periodo.modo === 'total'
          ? {}
          : { meses: periodo.mes, anio: periodo.anio };
      const res = await dashboardAvanzadoAPI.getDatos(params);
      setResumenFinanciero(res.data?.totales || null);
    } catch (err) {
      console.error('Error cargando resumen financiero por periodo:', err);
      setResumenFinanciero(null);
    } finally {
      setLoadingResumenFinanciero(false);
    }
  }, [resumenFinancieroPeriodo]);

  useEffect(() => {
    if (user && user.rol === 'JEFE') {
      loadDashboardData();
      cargarResumenFinanciero();
    }
  }, [user]);

  if (user && user.rol === 'PERSONAL') {
    return <PersonalDashboard />;
  }

  if (!user || user.rol !== 'JEFE') {
    return (
      <div className="container-fluid p-4">
        <div className="alert alert-warning" role="alert">
          <h4 className="alert-heading">Acceso Restringido</h4>
          <p>No tienes permisos para acceder a este dashboard.</p>
          <p className="text-muted">Tu rol actual: <strong>{user?.rol || 'No definido'}</strong></p>
          <hr />
          <p className="mb-0">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate('/expedientes', { replace: true })}
            >
              Ir a Expedientes
            </button>
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger m-3" role="alert">
        <h4 className="alert-heading">Error al cargar el dashboard</h4>
        <p>{error}</p>
        <button type="button" className="btn btn-primary btn-sm" onClick={loadDashboardData}>
          Reintentar
        </button>
      </div>
    );
  }

  return (
    <DashboardClaude
      kpis={kpis}
      deudas={deudas}
      vencimientos={vencimientos}
      ingresosMensuales={ingresosMensuales}
      resumenFinanciero={resumenFinanciero}
      resumenPeriodo={resumenFinancieroPeriodo}
      loadingResumen={loadingResumenFinanciero}
      onCambiarPeriodo={(nuevoPeriodo, totales) => {
        setResumenFinancieroPeriodo(nuevoPeriodo);
        if (totales) setResumenFinanciero(totales);
      }}
      onRefresh={() => {
        loadDashboardData();
        cargarResumenFinanciero();
      }}
    />
  );
};

export default Dashboard;
